import type { OurContext } from '../context';
import type { ParsedClaims } from '../context/claims';
import { env } from '../util/env';
import { buildStandardHeaders, request } from '../util/network';

export default async function validateClaims(
  context: OurContext,
  token?: string
): Promise<ParsedClaims | null> {
  if (!token) {
    return null;
  }
  try {
    const host = env.VITE_API_HOST;
    const headers = buildStandardHeaders(context.apiSubscriptionId);

    const response = await request(
      `${host}/validate-token?token=${token}&Accept-Language=no`,
      'GET',
      headers
    );
    if (response?.status === 200) {
      return response.json();
    } else {
      return null;
    }
  } catch {
    return null;
  }
}
